// src/services/whatsappService.js

// 1. Función para el Directorio de Propietarios (Credenciales de Acceso)
export async function enviarCredencialesWhatsAppDirecto(telefonoDestino, nombrePropietario, departamento, usuario, password, nombreEdificio) {
  try {
    if (!telefonoDestino || String(telefonoDestino).trim() === '') {
      throw new Error("El propietario no tiene un número de teléfono válido registrado.");
    }

    const telefonoStr = String(telefonoDestino).trim();
    let telefonoLimpio = '';

    if (telefonoStr.startsWith('+')) {
      telefonoLimpio = telefonoStr.replace(/[^\d]/g, '');
    } else {
      const soloDigitos = telefonoStr.replace(/\D/g, '');
      if (soloDigitos.length === 9) {
        telefonoLimpio = '51' + soloDigitos;
      } else {
        telefonoLimpio = soloDigitos;
      }
    }

    const mensajeCredenciales = `MMD&L Edificios SAC
"Calidad y honestidad en la administración de su edificio."

Estimado(a) ${nombrePropietario},
Le damos la bienvenida al sistema digital de administración de ${nombreEdificio}.

----------------------------------------
ACCESO AL PORTAL DEL PROPIETARIO
----------------------------------------
app.mmdledificiossac.com

----------------------------------------
DATOS DE SU INMUEBLE
----------------------------------------
Departamento: ${departamento}
Usuario de Acceso: ${usuario}
Contraseña Temporal: ${password}

Desde este portal usted podrá consultar el historial de cuotas de mantenimiento, descargar sus recibos oficiales en PDF, subir sus comprobantes o vouchers de pago y realizar reservas de las áreas sociales.

Si tiene alguna duda o inconveniente con su acceso, no dude en comunicarse directamente con la administración.`;

    await navigator.clipboard.writeText(mensajeCredenciales);
    const urlWhatsApp = `https://wa.me/${telefonoLimpio}?text=${encodeURIComponent(mensajeCredenciales)}`;
    window.open(urlWhatsApp, '_blank');

    return { success: true };
  } catch (error) {
    console.error("Error al procesar WhatsApp de credenciales:", error);
    return { success: false, error: error.message };
  }
}

// 2. Función exclusiva para Previsualización y Aprobación (Aviso de Recibo de Mantenimiento)
export async function enviarReciboWhatsAppDirecto(telefonoDestino, nombrePropietario, departamento, mes, anio, cuotaFormateada, fechaEmision, fechaVencimiento, pdfUrl, nombreEdificio) {
  try {
    if (!telefonoDestino || String(telefonoDestino).trim() === '') {
      throw new Error("El propietario no tiene un número de teléfono válido registrado.");
    }

    const telefonoStr = String(telefonoDestino).trim();
    let telefonoLimpio = '';

    if (telefonoStr.startsWith('+')) {
      telefonoLimpio = telefonoStr.replace(/[^\d]/g, '');
    } else {
      const soloDigitos = telefonoStr.replace(/\D/g, '');
      if (soloDigitos.length === 9) {
        telefonoLimpio = '51' + soloDigitos;
      } else {
        telefonoLimpio = soloDigitos;
      }
    }

    // Identificador de recibo formateado
    const idRecibo = `REC-${String(nombreEdificio).toUpperCase().replace(/\s+/g, '-')}-${departamento}-${String(mes || 'ACTUAL').toUpperCase()}`;

    // Mensaje con el texto exacto que solicitaste y el enlace apuntando al portal principal
    const mensajeRecibo = `MMD&L EDIFICIOS SAC
"Calidad y honestidad en la administración de su edificio."

Estimado(a) ${nombrePropietario},
Le hacemos llegar el estado de su cuota de mantenimiento correspondiente al periodo actual de su edificio.

----------------------------------------
DETALLE DEL RECIBO
----------------------------------------
N° de Recibo: ${idRecibo}
Mes: ${mes || 'No especificado'}
Año: ${anio || 'No especificado'}
Fecha de Emisión: ${fechaEmision || 'No especificada'}
Fecha de Vencimiento: ${fechaVencimiento || 'No especificada'}
Total a Pagar: ${cuotaFormateada}

----------------------------------------
VER MI RECIBO EN EL PORTAL
----------------------------------------
app.mmdledificiossac.com

Atentamente,
MMD&L EDIFICIOS SAC
"Calidad y honestidad en la administración de su edificio."`;

    await navigator.clipboard.writeText(mensajeRecibo);
    const urlWhatsApp = `https://wa.me/${telefonoLimpio}?text=${encodeURIComponent(mensajeRecibo)}`;
    window.open(urlWhatsApp, '_blank');

    return { success: true };
  } catch (error) {
    console.error("Error al procesar WhatsApp de recibo:", error);
    return { success: false, error: error.message };
  }
}